import script from "./ConfirmSlideDeckModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmSlideDeckModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmSlideDeckModal.vue?vue&type=style&index=0&id=21e13dc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e13dc0"]])

export default __exports__